import Actions                  from 'Redux/Actions';
import { EventRepository }      from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const sendBuyerMailEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.sendBuyerMailRequest.type),
    mergeMap(action => from(EventRepository.sendBuyerMail(action.payload.id, {
      subject: action.payload.subject,
      message: action.payload.message,
      eventTicketId: action.payload.eventTicketId,
    }))
      .pipe(
        mergeMap(({ recipientCount }) => {
          message.success(`Die E-Mail wurde an ${recipientCount} Käufer versendet.`);

          return from([
            Actions.sendBuyerMailSuccess({ recipientCount }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.sendBuyerMailFailure({ error })
          ]);
        })
      )
    ),
  );
};
